/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel =
  (typeof ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel)[keyof typeof ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel];

export const ApiFrontendConfigurationRetrieve200SettingsPriceTransparencyLevel = {
  full: 'full',
  lite: 'lite',
  none: 'none',
} as const;
